import { Component } from "@angular/core";

@Component({
    selector: "app-overview",
    templateUrl: "./overview.component.html",
    styleUrls: ["./overview.component.css"],
    standalone: false
})
export class OverviewComponent {

}